import { IdentityServerConfig } from './types/main';

let identityServerConfig: IdentityServerConfig = {
    authority: undefined,
    scope: undefined,
    grant_type: undefined,
    client_id: undefined,
    tenant_uid: undefined,
    tuid: undefined,
    response_type: undefined,
    acr_values: undefined,
    redirect_uri: undefined,
    post_logout_redirect_uri: undefined,
    silent_redirect_uri: undefined,
    response_mode: undefined,
    // Renewal is owned by oidc-client's SilentRenewService. Without it the access token is never
    // renewed, which makes `addMemberToken()` fall back to a client_credentials token (404s on
    // user-scoped endpoints) and then fires `accessTokenExpired` -> logout while the user is active.
    //
    // `accessTokenExpiringNotificationTime` must stay comfortably BELOW the Identity Server's access
    // token lifetime (currently 3600s). If it is ever >= that lifetime, `AccessTokenEvents.load()`
    // clamps the expiring timer to 1 second and every renewal immediately schedules the next one.
    automaticSilentRenew: true,
    accessTokenExpiringNotificationTime: 120,
    silentRequestTimeout: 20000,
};

export const setupIdentityConfig = (data: Partial<IdentityServerConfig>): void => {
    // Skip keys whose runtime value is undefined so a config file that omits a key keeps the
    // default above instead of blanking it out.
    const defined = Object.fromEntries(
        Object.entries(data).filter(([, value]) => value !== undefined),
    ) as Partial<IdentityServerConfig>;

    identityServerConfig = {
        ...identityServerConfig,
        ...defined,
    };
};

export const getIdentityServerAuthorityUrl = (): string => {
    if (identityServerConfig.authority !== undefined) {
        return `${identityServerConfig.authority}`;
    }

    return '';
};

export const getIdentityServerConfig = (): IdentityServerConfig => identityServerConfig;
